import { Html } from '@react-three/drei';
import type { StoryText } from '../../types';

interface Props {
  storyText: StoryText;
}

/**
 * 编辑画布中的文本卡片（DOM 叠加层）
 * 与运行时 StoryText 表现一致：大字号、可配置颜色/背景
 */
export function EditorTextBox({ storyText }: Props) {
  return (
    <group position={[storyText.position.x, storyText.position.y, storyText.position.z]}>
      <Html
        center
        zIndexRange={[5, 0]}
        style={{
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      >
        <div
          style={{
            maxWidth: 460,
            fontSize: storyText.fontSize,
            color: storyText.color,
            fontWeight: storyText.bold ? 700 : 400,
            textAlign: storyText.align,
            lineHeight: 1.6,
            textShadow: '0 2px 8px rgba(0,0,0,0.65)',
            padding: '8px 16px',
            borderRadius: 12,
          }}
        >
          {storyText.content}
        </div>
      </Html>
    </group>
  );
}